<template>
	<div>
		<nio-header-nav position="relative" @back="handleClose" :is-white="true">
			<div class="right-btn-list">
				<nio-icon :size="28" name="icon_sell_car_xl" @click="onRightButtonClick" />
			</div>
		</nio-header-nav>
		<p class="page-title">
			我要卖车
		</p>

		<div class="content-area">
			<img style="width: 100px" :src="ImgEmpty" />
			<p class="tips">你名下暂无蔚来车辆</p>
			<nio-button @click="handleClose" type="btn_solid_l">返回二手车商城</nio-button>
		</div>
	</div>
</template>

<script>
import ImgEmpty from '@/assets/images/empty-seller.png'
import link from '@/util/link'
import nativeHybrid from '@/util/nativeHybrid'

export default {
	name: 'Index',
	data() {
		return {
			ImgEmpty
		}
	},
	methods: {
		handleClose() {
			nativeHybrid.closeSyn()
		},
		onRightButtonClick() {
			link.goToSeller('/application')
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.page-title {
	margin-top: 20px;
	padding-left: 20px;
	@include headline_1();
	color: $text_primary;
}
.content-area {
	margin-top: 105px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	.tips {
		margin-top: 32px;
		margin-bottom: 40px;
		@include subtitle_3();
		color: $text_tertiary;
	}
}
</style>
